(() => {
  if (window.bdmInstantGuideReady) return;
  window.bdmInstantGuideReady = true;

  const triggerSelector = [
    "[data-bdm-instant-guide]",
    'a[href*="/pages/guia-de-tallas"]',
    'a[href*="/pages/como-encontrar-tu-talla"]',
  ].join(",");

  const dialog = document.getElementById("bdm-instant-guide");
  const template = document.getElementById("bdm-instant-guide-template");
  const content = dialog?.querySelector("[data-bdm-instant-guide-content]");
  const closeButton = dialog?.querySelector("[data-bdm-instant-guide-close]");
  if (!dialog || !template || !content || !closeButton) return;

  let opener = null;
  let hydrated = false;

  function hydrate() {
    if (hydrated) return;
    content.append(template.content.cloneNode(true));
    hydrated = true;
  }

  function openGuide(control) {
    hydrate();
    opener = control;
    control.setAttribute("aria-expanded", "true");
    document.documentElement.classList.add("bdm-instant-guide-open");

    if (typeof dialog.showModal === "function") {
      if (!dialog.open) dialog.showModal();
    } else {
      dialog.setAttribute("open", "");
      dialog.setAttribute("aria-modal", "true");
    }
    closeButton.focus({ preventScroll: true });
  }

  function closeGuide() {
    if (typeof dialog.close === "function" && dialog.open) {
      dialog.close();
      return;
    }
    dialog.removeAttribute("open");
    restorePage();
  }

  function restorePage() {
    document.documentElement.classList.remove("bdm-instant-guide-open");
    if (opener) {
      opener.setAttribute("aria-expanded", "false");
      opener.focus({ preventScroll: true });
    }
    opener = null;
  }

  document.addEventListener("click", (event) => {
    const trigger = event.target.closest(triggerSelector);
    if (trigger) {
      event.preventDefault();
      openGuide(trigger);
      return;
    }

    if (event.target.closest("[data-bdm-instant-guide-close]")) {
      event.preventDefault();
      closeGuide();
    }
  });

  dialog.addEventListener("click", (event) => {
    if (event.target !== dialog) return;
    const bounds = dialog.getBoundingClientRect();
    const inside =
      event.clientX >= bounds.left &&
      event.clientX <= bounds.right &&
      event.clientY >= bounds.top &&
      event.clientY <= bounds.bottom;
    if (!inside) closeGuide();
  });

  dialog.addEventListener("close", restorePage);
  dialog.addEventListener("cancel", () => {
    window.setTimeout(restorePage, 0);
  });
})();
